import React, { useEffect, useState, useRef } from "react";
import SEO from "../../BaseComponents/SEO";
import Header from "../BaseComponents/Header";
import HIFotterMain from "../BaseComponents/Footer";
import { Link, useLocation } from "react-router-dom";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import {
  getHiValuePlusProductFilterList,
  GetHVPGetCategoryList,
  GetHVPGetDealerCityList,
  getOEMProductList,
  getHVPGetProductsListAPI,
  getCustomerProfile,
  getStateList,
  getCityList,
  GetHVPGetALLModelList,
  NotifyMeAPI,
  NotifyMeOTPVerify,
  GetHVPGetModelList,
  googleCaptchaAPIKey,
} from "../../../networkCalls";
import {
  Autocomplete,
  FormControlLabel,
  FormGroup,
  Slider,
  TextField,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
  IconButton,
  Drawer,
  Pagination, // Added for pagination
  Stack,      // Added for pagination
} from "@mui/material";
import { actionTypes, useStateValue } from "../../../store";

import { GridIcon, HamburgerIcon, ListIcon } from "../BaseComponents/icon";
import RefurbishedProductGridBoxOEM from "../BaseComponents/ProductCels/RefurbishedProduct";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { Button, Modal } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import { set } from "date-fns";
import ReCAPTCHA from "react-google-recaptcha";

const validationSchema1 = yup.object({
  name: yup.string().required("Name is required"),
  phone: yup.string().required("Phone Number is required"),
  email: yup.string().optional().email("Enter a valid email"),
  productname: yup.string().required("Product Name is required"),
  categoryname: yup.string().required("Category is required"),
});

const validationSchema2 = yup.object({
  otp: yup
    .string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .length(6, "OTP must be 6 digits")
    .required("OTP is required"),
});

const HIProductList = () => {
  const location = useLocation();
  const [{ token, huid }, dispatch] = useStateValue();
  const TEST_SITE_KEY = googleCaptchaAPIKey;
  const recaptchaRef = React.createRef();
  const [captchavalue, setCaptchavalue] = React.useState("");
  const onVerifyCaptcha = (captchavalue) => {
    setCaptchavalue(captchavalue );
  };

  const [agree, setAgree] = useState(false);
  const haveAgree = (event) => {
    setAgree(event.target.checked);
  };
  const [cityvalue, setCityValue] = useState(null);
  const [city, setCity] = useState([]);
  const [relevancy, setRelevancy] = useState(null);
  const [productData, setProductData] = useState([]);
  const [productCount, setproductCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filterList, setFilterList] = useState([]);
  const [initialfilterList, setInitialFilterList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [totalPages, setTotalpages] = useState(1);
  const isInitialMount = useRef(true);

  const [relevancylist, setRelevancyList] = useState([
    { id: 1, label: "Price: Low to High", value: "PriceASC" },
    { id: 2, label: "Price: High to Low", value: "PriceDESC" },
    { id: 3, label: "Name Ascending", value: "NameASC" },
    { id: 4, label: "Name Descending", value: "NameDESC" },
    { id: 5, label: "Oldest on Top", value: "PRDDESC" },
    { id: 6, label: "Newest on Top", value: "PRDASC" },
  ]);

  const [activeview, setActiveView] = useState("grid");

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [priceRange, setPriceRange] = useState({});
  const [categoryListLoaded, setCategoryListLoaded] = useState(false);

  const pullCategoryList = () => {
    GetHVPGetCategoryList().then((res) => {
      if (res.data.status === 1) {
        const data = res.data.categoryList.map((item) => ({
          id: item.id,
          label: item.name,
          image: item.image,
        }));
        setCategoryList(data);
        setCategoryListLoaded(true);
      }
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    if (id && categoryListLoaded) {
      setSelectedCategories([{ categoryId: Number(id) }]);
    }
  }, [categoryListLoaded]);

  const handleCategoryChange = (event, categoryId) => {
    const checked = event.target.checked;
    setSelectedCategories((prev) =>
      checked
        ? [...prev, { categoryId: categoryId }]
        : prev.filter((id) => id.categoryId !== categoryId)
    );
  };

  const handleFilterChange = (filterName, attribute) => (event) => {
    const checked = event.target.checked;
    setSelectedFilters((prev) => {
      const current = prev[filterName] || [];
      return {
        ...prev,
        [filterName]: checked
          ? [...current, attribute]
          : current.filter((a) => a !== attribute),
      };
    });
  };

  const handlePriceChange = (filterName, newValue) => {
    setPriceRange((prev) => ({
      ...prev,
      [filterName]: newValue,
    }));
  };

  const clearAllFilters = () => {
    setSelectedCategories([]);
    setSelectedFilters({});
    setFilterList(initialfilterList);
    setPriceRange({});
    setRelevancy(null);
    setCityValue(null);
    setSearch("");
    setPage(1);
    setHasMore(true);
    setproductCount(0);
  };

  useEffect(() => {
    GetHVPGetDealerCityList()
      .then((res) => {
        const data1 = res?.data?.cityList?.map((item) => ({
          id: item.id,
          label: item.name,
          isMetro: item.isMetro,
        }));
        setCity(data1);
      })
      .catch((err) => console.log(err));

    getHiValuePlusProductFilterList()
      .then((res) => {
        setFilterList(res?.data?.filtersList);
        setInitialFilterList(res?.data?.filtersList);
      })
      .catch((err) => console.log(err));

    pullCategoryList();
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      setPage(1);
    }
  }, [selectedCategories, filterList, relevancy, cityvalue, search]);

  // Handle Page change for Pagination component
  const handlePageChange = (event, value) => {
    setPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // REWORKED: Fetch products for specific page (Pagination Logic)
  useEffect(() => {
    const data = new FormData();
    data.append("all", "true");
    data.append("search", search);
    data.append("page", page);
    data.append(
      "category",
      selectedCategories.length > 0 ? JSON.stringify(selectedCategories) : []
    );

    if (
      Object.keys(selectedFilters).length > 0 ||
      Object.keys(priceRange).length > 0
    ) {
      data.append("filter", JSON.stringify(filterList));
    }

    data.append(
      "city",
      cityvalue === null || cityvalue === "" ? "" : cityvalue.label
    );
    data.append("sort", relevancy === null ? "" : relevancy.value);

    setLoading(true);

    getHVPGetProductsListAPI(data)
      .then((res) => {
        if (res.data.status === 1) {
          const { List, Count, totalPages: apiTotalPages, hasMore: apiHasMore } = res.data.productsList;

          // Replace data for pagination instead of accumulating
          setProductData(List || []);
          setproductCount(Count || 0);
          setTotalpages(Number(apiTotalPages) || 1);
          setHasMore(apiHasMore === 1);
        } else {
          setProductData([]);
          setproductCount(0);
          setTotalpages(1);
          setHasMore(false);
        }
      })
      .catch(() => {
        setProductData([]);
        setproductCount(0);
        setHasMore(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [page, selectedCategories, filterList, relevancy, cityvalue, search]);

  const [stateList, setStateList] = React.useState([]);
  const pullStateList = (value) => {
    var data = new FormData();
    data.append("countryId", "IND");
    getStateList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setStateList(res.data.stateList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  const [state, setState] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityList, setCityList] = React.useState([]);
  const pullCityList = (value) => {
    var data = new FormData();
    data.append("stateId", value);
    getCityList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCityList(res.data.cityList);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };

  function valuetext(value) {
    return `${value}`;
  }
  const [show, setShow] = useState(false);
  const [changetoOTP, setChangetoOTP] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [susMessage, setSusMessage] = useState("");
  const [requestId, setRequestID] = useState("");

  useEffect(() => {
    const preSelected = {};
    filterList.forEach((f) => {
      if (f.typeLabel === "checkbox") {
        const attrs = JSON.parse(f.attributes);
        preSelected[f.filterName] = attrs
          .filter((a) => a.default === 1)
          .map((a) => a.attribute);
      }
    });
    setSelectedFilters(preSelected);
  }, [filterList]);
  const [customerData, setCustomerData] = React.useState(null);
  const [initialdata, setInitialData] = React.useState({
    name: "",
    phone: "",
    email: "",
    pincode: "",
    state: "",
    city: "",
    productname: "",
  });
  const [customerDataloaded, setCustomerDataLoaded] = React.useState(false);
  const callApiProfile = () => {
    var data = new FormData();
    data.append("customerId", huid);
    // data.append("XAuth", token);
    getCustomerProfile(data).then((res) => {
      switch (res.data.status) {
        case 1:
          setCustomerData(res.data.customerData);
          setInitialData({
            name: `${res.data.customerData?.firstName} ${res.data.customerData?.lastName}`,
            phone: `${res.data.customerData?.phone}`,
            email: `${res.data.customerData?.email}`,
            pincode: "",
            state: "",
            city: "",
            productname: "",
          });
          setCustomerDataLoaded(true);
          return true;
        case 0:
          setErrMessage(res.data.msz);
          setCustomerDataLoaded(false);
          break;
        case 2:
          setCustomerDataLoaded(false);
          break;
        default:
          return;
      }
    });
  };

  const formikOtp = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: initialdata.name,
      phone: initialdata.phone,
      email: initialdata.email,
      pincode: "",
      state: "",
      city: "",
      productname: "",
      productid: "",
      categoryname: "",
      categoryid: "",
    },
    validationSchema: validationSchema1,
    onSubmit: (values) => {
      var data = new FormData();
      data.append("name", values.name);
      data.append("phone", values.phone);
      data.append("email", values.email);
      data.append("pincode", values.pincode);
      data.append("state", values.state);
      data.append("city", values.city);
      data.append("model", values.productid);
      data.append("category", values.categoryid);
      data.append("captcha", captchavalue); 
      NotifyMeAPI(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setRequestID(res.data.requestId);
            setChangetoOTP(true);
            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          default:
            return;
        }
      });
    },
  });
  const formikOtpVerify = useFormik({
    enableReinitialize: true,
    initialValues: {
      otp: "",
    },
    validationSchema: validationSchema2,
    onSubmit: (values) => {
      var data = new FormData();
      data.append("otp", values.otp);
      data.append("requestId", requestId);
      NotifyMeOTPVerify(data).then((res) => {
        switch (res.data.status) {
          case 1:
            setErrMessage("");
            setSusMessage(res.data.msz);
            setOTPverificationRespoanse(res.data.msz);
            setChangetoOTP(false);
            setShow(false);
            setVerificationShow(true);
            return true;
          case 0:
            setErrMessage(res.data.msz);
            break;
          default:
            return;
        }
      });
    },
  });
  const handleClose = () => {
    setShow(false);
    setChangetoOTP(false);
  };

  const [Verificationshow, setVerificationShow] = useState(false);
  const [otpverificationresponse, setOTPverificationRespoanse] = useState("");
  const [modellist, setModelList] = useState([]);
  const pullModalList = (value, newvalue) => {
    var data = new FormData();
    data.append("categoryId", value);
    data.append("subCategoryId", "");
    GetHVPGetModelList(data).then((res) => {
      switch (res.data.status) {
        case 1:
          const data = res.data.modelListArray.map((item) => ({
            id: item.id,
            label: item.name,
            categoryId: item.categoryId,
            category: item.category,
            subCategoryId: item.subCategoryId,
            subCategory: item.subCategory,
          }));
          setModelList(data);
          return true;
        case 0:
          break;
        default:
          return;
      }
    });
  };
  useEffect(() => {
    pullStateList();
    callApiProfile();
  }, []);
  const enabledbtncapt = captchavalue != "" && agree;

  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const [showConsent, setShowConsent] = useState(false);

  return (
    <>
      <Header />

      {/* City Strip */}
      <div className="hivalueplusproductlistcitystrip py-2 py-lg-0 py-md-0">
        <div className="d-flex flex-column flex-lg-row flex-md-column  justify-content-between align-items-center container gap-3 px-0">
          <div className="d-flex justify-content-between justify-content-lg-start justify-content-md-start align-items-center gap-2">
            <div className="d-flex align-items-center gap-2">
              <LocationOnOutlinedIcon color="white" />
              <span>Showing Products in:</span>
            </div>
            <Autocomplete
              options={city}
              value={cityvalue}
              onChange={(event, newValue) => setCityValue(newValue)}
              getOptionLabel={(option) => option.label}
              sx={{
                width: { lg: 200, md: 200, xs: 120 },
                "& .MuiInputBase-root": { color: "white" },
                "& .MuiInputLabel-root": { color: "white" },
                "& .MuiSvgIcon-root": { color: "white" },
                "& .MuiInput-underline:before": { borderBottomColor: "white" },
                "& .MuiInput-underline:hover:before": { borderBottomColor: "white" },
                "& .MuiInput-underline:after": { borderBottomColor: "white" },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  placeholder="All Cities"
                  InputLabelProps={{ sx: { color: "white" } }}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      "&::placeholder": { color: "white", opacity: 1 },
                      input: { "&::placeholder": { color: "white", opacity: 1 } },
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="d-flex flex-lg-row flex-md-column align-items-center gap-3">
            <TextField
              placeholder="Search Keyword for Models"
              variant="outlined"
              fullWidth
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                sx: {
                  color: "white",
                  height: 42,
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "white" },
                },
              }}
              InputLabelProps={{ sx: { color: "white" } }}
              sx={{
                width: "fit-content",
                minWidth: { lg: 260, md: 260, xs: 200 },
                borderRadius: 1,
                input: {
                  color: "white",
                  "&::placeholder": { color: "white", opacity: 1 },
                },
              }}
            />
            <span
              className=" border border-white text-white rounded px-3 hinotifybtn pointer"
              onClick={() => setShow(true)}
            >
              Notify Me
            </span>
          </div>
        </div>
      </div>

      {/* Main Section */}
      <div className="hivalueplusproductlistmain container">
        <div className="row g-3">
          {/* Filters Section */}
          <div className="col-12 col-lg-3 d-none d-lg-block d-md-block ">
            <div
              className="border rounded hivalueplusproductfiltersection"
              style={{
                position: "sticky",
                top: "20px",
                height: "calc(100vh - 40px)",
                overflowY: "auto",
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="hivalueplusfiltersectionheading">Filters</div>
                <div
                  className="hivalueplusfiltersectionclearall"
                  onClick={clearAllFilters}
                  style={{ cursor: "pointer", color: "#0873bb" }}
                >
                  Clear all
                </div>
              </div>

              {/* Categories */}
              <div className="hivalueplusfilterdivmargin">
                <p className="hivalueplusslidertext mb-1">Categories</p>
                <FormGroup>
                  {categoryList.map((value, id) => (
                    <FormControlLabel
                      key={id}
                      className="border px-2 py-1 my-1"
                      control={
                        <Checkbox
                          checked={selectedCategories.some((obj) => obj.categoryId === value.id)}
                          onChange={(e) => handleCategoryChange(e, value.id)}
                        />
                      }
                      label={value.label}
                    />
                  ))}
                </FormGroup>
              </div>

              {/* Dynamic Filters */}
              {filterList.map((val, id) => (
                <div key={id} className="hivalueplusfilterdivmargin">
                  <p className="hivalueplusslidertext mb-1">{val.filterName}</p>
                  {val.typeLabel === "checkbox" ? (
                    <FormGroup>
                      {JSON.parse(val?.attributes).map((value, idx) => (
                        <FormControlLabel
                          key={idx}
                          className="border px-2 py-1 my-1"
                          control={
                            <Checkbox
                              checked={value.default === 1}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                setFilterList((prevList) =>
                                  prevList.map((item) => {
                                    if (item.filterName === val.filterName) {
                                      const updatedAttrs = JSON.parse(item.attributes).map((attr) =>
                                        attr.attribute === value.attribute
                                          ? { ...attr, default: isChecked ? 1 : 0 }
                                          : attr
                                      );
                                      return { ...item, attributes: JSON.stringify(updatedAttrs) };
                                    }
                                    return item;
                                  })
                                );
                                handleFilterChange(val.filterName, value.attribute)(e);
                              }}
                            />
                          }
                          label={value.attribute}
                        />
                      ))}
                    </FormGroup>
                  ) : val.typeLabel === "slider" ? (
                    <div className="px-1">
                      {(() => {
                        const attributes = JSON.parse(val.attributes);
                        const sliderValue =
                          attributes.default !== undefined &&
                            attributes.default !== null &&
                            attributes.default !== "" &&
                            attributes.default !== 0
                            ? attributes.default
                            : attributes.center;
                        return (
                          <>
                            <Slider
                              value={sliderValue}
                              onChange={(e, newValue) => {
                                handlePriceChange(val.filterName, newValue);
                                setFilterList((prevList) =>
                                  prevList.map((item) => {
                                    if (item.filterName === val.filterName) {
                                      const attrs = JSON.parse(item.attributes);
                                      const updatedAttrs = { ...attrs, default: newValue };
                                      return { ...item, attributes: JSON.stringify(updatedAttrs) };
                                    }
                                    return item;
                                  })
                                );
                              }}
                              min={attributes.min}
                              max={attributes.max}
                              valueLabelDisplay="auto"
                              sx={{ height: "10px", color: "#0873BB" }}
                            />
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", color: "#000" }}>
                              <span className="hivaluesliderlabel">
                                <CurrencyRupeeIcon fontSize="small" /> {attributes.min}
                              </span>
                              <span className="hivaluesliderlabel">
                                <CurrencyRupeeIcon fontSize="small" /> {attributes.max}
                              </span>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  ) : val.typeLabel === "radio" ? (
                    <RadioGroup
                      value={JSON.parse(val.attributes).find((a) => a.default === 1)?.attribute || ""}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setFilterList((prevList) =>
                          prevList.map((item) => {
                            if (item.filterName === val.filterName) {
                              const updatedAttrs = JSON.parse(item.attributes).map((attr) => ({
                                ...attr,
                                default: attr.attribute === selectedValue ? 1 : 0,
                              }));
                              return { ...item, attributes: JSON.stringify(updatedAttrs) };
                            }
                            return item;
                          })
                        );
                        handleFilterChange(val.filterName, selectedValue)(e);
                      }}
                    >
                      {JSON.parse(val.attributes).map((value, idx) => (
                        <FormControlLabel
                          className="border px-2 py-1 my-1"
                          key={idx}
                          value={value.attribute}
                          control={<Radio />}
                          label={value.attribute}
                        />
                      ))}
                    </RadioGroup>
                  ) : (
                    <TextField
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={JSON.parse(val.attributes)?.default || ""}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setFilterList((prevList) =>
                          prevList.map((item) => {
                            if (item.filterName === val.filterName) {
                              const attrs = JSON.parse(item.attributes);
                              const updatedAttrs = { ...attrs, default: newValue };
                              return { ...item, attributes: JSON.stringify(updatedAttrs) };
                            }
                            return item;
                          })
                        );
                        handleFilterChange(val.filterName, newValue)(e);
                      }}
                      placeholder={`${val.placeholder}`}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Product Section */}
          <div className="col-12 col-lg-9">
            <div className="p-2 h-100 w-100">
              <div className="d-flex flex-column flex-lg-row flex-md-row gap-2 justify-content-between align-items-center w-100">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    <div className="hivalueplusproductviewheading">Refurbished Products</div>
                    <div className="hivalueplusproductviewsubheading">{productCount} products found</div>
                  </div>
                  <div className="d-block d-lg-none d-md-none d-sm-none pointer">
                    <IconButton onClick={toggleDrawer(true)}
                      size="medium"
                      edge="start"
                      color="inherit"
                      aria-label="open drawer"
                      sx={{ mr: 0 }}>
                      <HamburgerIcon />
                    </IconButton>
                  </div>
                </div>

                {/* Relevancy + View Toggle */}
                <div className="d-flex justify-content-between justify-content-lg-end justify-content-md-end  gap-3 w-100">
                  <Autocomplete
                    options={relevancylist}
                    value={relevancy}
                    onChange={(event, newValue) => setRelevancy(newValue)}
                    getOptionLabel={(option) => option.label}
                    sx={{ width: { lg: 200, md: 200, xs: 240 } }}
                    renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Select Relevancy" />}
                  />

                  <div className="d-flex rounded-1 align-items-center">
                    <div
                      className={activeview === "grid" ? "hivalueiconborders p-3" : "hivalueiconborder p-3"}
                      onClick={() => setActiveView("grid")}
                    >
                      <GridIcon color={activeview === "grid" ? "#0873bb" : "#969696"} />
                    </div>
                    <div
                      className={activeview === "list" ? "hivaluelisticonborders p-3" : "hivaluelisticonborder p-3"}
                      onClick={() => setActiveView("list")}
                    >
                      <ListIcon color={activeview === "list" ? "#0873bb" : "#969696"} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Product List Grid */}
              <div className="mt60">
                <div className="row g-3">
                  {loading ? (
                    <div className="text-center w-100 py-5">Loading...</div>
                  ) : productData && productData.length > 0 ? (
                    <>
                      {productData.map((itemin, key) => (
                        <div key={key} className={`${activeview === "grid" ? "col-6 col-sm-12 col-lg-4" : "col-12"}`}>
                          <RefurbishedProductGridBoxOEM itemin={itemin} issold={itemin.soldOut === 1} view={activeview} />
                        </div>
                      ))}

                      {/* PAGINATION COMPONENT */}
                      <div className="col-12 d-flex justify-content-center mt-5 mb-4">
                        <Stack spacing={2}>
                          <Pagination
                            count={totalPages}
                            page={page}
                            onChange={handlePageChange}
                            color="primary"
                            variant="outlined"
                            // shape="rounded"
                            sx={{
                              "& .MuiPaginationItem-root": {
                                color: "#0873bb", // text color for unselected
                                borderColor: "#0873bb", // border for outlined variant
                                "&:hover": {
                                  backgroundColor: "rgba(8, 115, 187, 0.1)", // light blue hover
                                },
                              },
                              "& .MuiPaginationItem-root.Mui-selected": {
                                backgroundColor: "#0873bb", // ✅ your base color for active background
                                color: "#fff", // white text
                                borderColor: "#0873bb",
                                "&:hover": {
                                  backgroundColor: "#065f99", // slightly darker on hover
                                  borderColor: "#065f99",
                                },
                              },
                            }}
                          />
                        </Stack>
                      </div>
                    </>
                  ) : !loading && selectedCategories.length > 0 ? (
                    <div className="text-center w-100 py-5">
                      <p>No products found for the selected category.</p>
                      <div className=" fw-bold d-flex justify-content-center align-items-center">
                        <span className="hivalueplussectionBtn me-2 w-25" onClick={() => setShow(true)}>Notify Me</span>
                      </div>
                    </div>
                  ) : !loading ? (
                    <div className="text-center w-100 py-5">No products found</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Drawer Section */}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <Box
          sx={{ width: { xs: 340, sm: 320 } }}
          role="presentation"
          className="mobile-left-nav py-5 px-3"
        >
          <div className="row g-3">
            <div className="col-12 col-lg-3">
              <div className="border rounded hivalueplusproductfiltersection h-100">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="hivalueplusfiltersectionheading">Filters</div>
                  <div
                    className="hivalueplusfiltersectionclearall"
                    onClick={() => {
                      clearAllFilters();
                      toggleDrawer(false);
                    }}
                    style={{ cursor: "pointer", color: "#0873bb" }}
                  >
                    Clear all
                  </div>
                </div>

                {/* Categories */}
                <div className="hivalueplusfilterdivmargin">
                  <p className="hivalueplusslidertext mb-1">Categories</p>
                  <FormGroup>
                    {categoryList.map((value, id) => (
                      <FormControlLabel
                        key={id}
                        className="border px-2 py-1 my-1"
                        control={
                          <Checkbox
                            checked={selectedCategories.some(
                              (obj) => obj.categoryId === value.id
                            )}
                            onChange={(e) => handleCategoryChange(e, value.id)}
                          />
                        }
                        label={value.label}
                      />
                    ))}
                  </FormGroup>
                </div>

                {/* Dynamic Filters */}
                {filterList.map((val, id) => (
                  <div key={id} className="hivalueplusfilterdivmargin">
                    <p className="hivalueplusslidertext mb-1">
                      {val.filterName}
                    </p>

                    {val.typeLabel === "checkbox" ? (
                      <FormGroup>
                        {JSON.parse(val?.attributes).map((value, idx) => (
                          <FormControlLabel
                            key={idx}
                            className="border px-2 py-1 my-1"
                            control={
                              <Checkbox
                                checked={value.default === 1}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;

                                  setFilterList((prevList) =>
                                    prevList.map((item) => {
                                      if (item.filterName === val.filterName) {
                                        const updatedAttrs = JSON.parse(
                                          item.attributes
                                        ).map((attr) =>
                                          attr.attribute === value.attribute
                                            ? {
                                              ...attr,
                                              default: isChecked ? 1 : 0,
                                            }
                                            : attr
                                        );
                                        return {
                                          ...item,
                                          attributes:
                                            JSON.stringify(updatedAttrs),
                                        };
                                      }
                                      return item;
                                    })
                                  );

                                  handleFilterChange(
                                    val.filterName,
                                    value.attribute
                                  )(e);
                                }}
                              />
                            }
                            label={value.attribute}
                          />
                        ))}
                      </FormGroup>
                    ) : val.typeLabel === "slider" ? (
                      <div className="px-1">
                        {(() => {
                          const attributes = JSON.parse(val.attributes);
                          const sliderValue =
                            attributes.default !== undefined &&
                              attributes.default !== null &&
                              attributes.default !== "" &&
                              attributes.default !== 0
                              ? attributes.default
                              : attributes.center;
                          return (
                            <>
                              <Slider
                                value={sliderValue}
                                onChange={(e, newValue) => {
                                  handlePriceChange(val.filterName, newValue);

                                  setFilterList((prevList) =>
                                    prevList.map((item) => {
                                      if (item.filterName === val.filterName) {
                                        const attrs = JSON.parse(
                                          item.attributes
                                        );
                                        const updatedAttrs = {
                                          ...attrs,
                                          default: newValue,
                                        };
                                        return {
                                          ...item,
                                          attributes:
                                            JSON.stringify(updatedAttrs),
                                        };
                                      }
                                      return item;
                                    })
                                  );
                                }}
                                min={attributes.min}
                                max={attributes.max}
                                valueLabelDisplay="auto"
                                sx={{ height: "10px", color: "#0873BB" }}
                              />

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  fontSize: "12px",
                                  color: "#000",
                                }}
                              >
                                <span className="hivaluesliderlabel">
                                  <CurrencyRupeeIcon fontSize="small" />{" "}
                                  {attributes.min}
                                </span>
                                <span className="hivaluesliderlabel">
                                  <CurrencyRupeeIcon fontSize="small" />{" "}
                                  {attributes.max}
                                </span>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    ) : val.typeLabel === "radio" ? (
                      <RadioGroup
                        value={
                          JSON.parse(val.attributes).find(
                            (a) => a.default === 1
                          )?.attribute || ""
                        }
                        onChange={(e) => {
                          const selectedValue = e.target.value;

                          setFilterList((prevList) =>
                            prevList.map((item) => {
                              if (item.filterName === val.filterName) {
                                const updatedAttrs = JSON.parse(
                                  item.attributes
                                ).map((attr) => ({
                                  ...attr,
                                  default:
                                    attr.attribute === selectedValue ? 1 : 0,
                                }));
                                return {
                                  ...item,
                                  attributes: JSON.stringify(updatedAttrs),
                                };
                              }
                              return item;
                            })
                          );

                          handleFilterChange(val.filterName, selectedValue)(e);
                        }}
                      >
                        {JSON.parse(val.attributes).map((value, idx) => (
                          <FormControlLabel
                            className="border px-2 py-1 my-1"
                            key={idx}
                            value={value.attribute}
                            control={<Radio />}
                            label={value.attribute}
                          />
                        ))}
                      </RadioGroup>
                    ) : (
                      <TextField
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={JSON.parse(val.attributes)?.default || ""}
                        onChange={(e) => {
                          const newValue = e.target.value;

                          setFilterList((prevList) =>
                            prevList.map((item) => {
                              if (item.filterName === val.filterName) {
                                const attrs = JSON.parse(item.attributes);
                                const updatedAttrs = {
                                  ...attrs,
                                  default: newValue,
                                };
                                return {
                                  ...item,
                                  attributes: JSON.stringify(updatedAttrs),
                                };
                              }
                              return item;
                            })
                          );

                          handleFilterChange(val.filterName, newValue)(e);
                        }}
                        placeholder={`${val.placeholder}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Box>
      </Drawer>

      {/* Notify Me Modal */}
      <Modal
        size="md"
        show={show}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => handleClose()}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => handleClose()}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className=" m-5">
            <div className="row">
              <div className="col-12">
                <h4 className=" m-0 fw-bold text-uppercase text-center">
                  <span className="txtdgray">Notify Me</span>
                </h4>
              </div>
              {changetoOTP ? (
                <form
                  className="col-12"
                  onSubmit={formikOtpVerify.handleSubmit}
                  autoComplete="off"
                >
                  <div>
                    <div className="mt-3">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="otp"
                        name="otp"
                        label="Enter 6 digit code *"
                        type="text"
                        value={formikOtpVerify.values.otp}
                        onChange={formikOtpVerify.handleChange}
                        onBlur={formikOtpVerify.handleBlur}
                        error={
                          formikOtpVerify.touched.otp &&
                          Boolean(formikOtp.errors.otp)
                        }
                        helperText={
                          formikOtpVerify.touched.otp &&
                          formikOtpVerify.errors.otp
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      >
                        Verify
                      </Button>
                    </div>
                  </div>
                </form>
              ) : (
                <form
                  className="col-12"
                  onSubmit={formikOtp.handleSubmit}
                  autoComplete="off"
                >
                  <div className="">
                    <Autocomplete
                      disablePortal
                      id="categoryname"
                      options={categoryList}
                      value={
                        categoryList.find(
                          (opt) => opt.label === formikOtp.values.categoryname
                        ) || null
                      }
                      onChange={(e, value) => {
                        formikOtp.setFieldValue(
                          "categoryname",
                          value?.label || ""
                        );
                        pullModalList(value?.id);
                        formikOtp.setFieldValue("categoryid", value?.id || "");
                      }}
                      onBlur={() =>
                        formikOtp.setFieldTouched("categoryname", true)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Category"
                          className="mb-2 w-100"
                          error={
                            formikOtp.touched.categoryname &&
                            Boolean(formikOtp.errors.categoryname)
                          }
                          helperText={
                            formikOtp.touched.categoryname &&
                            formikOtp.errors.categoryname
                          }
                        />
                      )}
                    />
                  </div>
                  <div className="">
                    <Autocomplete
                      disablePortal
                      id="productname"
                      options={modellist}
                      value={
                        modellist.find(
                          (opt) => opt.label === formikOtp.values.productname
                        ) || null
                      }
                      onChange={(e, value) => {
                        formikOtp.setFieldValue(
                          "productname",
                          value?.label || ""
                        );
                        formikOtp.setFieldValue("productid", value?.id || "");
                      }}
                      onBlur={() =>
                        formikOtp.setFieldTouched("productname", true)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          label="Model Name"
                          className="mb-2 w-100"
                          error={
                            formikOtp.touched.productname &&
                            Boolean(formikOtp.errors.productname)
                          }
                          helperText={
                            formikOtp.touched.productname &&
                            formikOtp.errors.productname
                          }
                        />
                      )}
                    />
                  </div>
                  <div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="name"
                        name="name"
                        label="Your Name *"
                        type="text"
                        value={formikOtp.values.name}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.name &&
                          Boolean(formikOtp.errors.name)
                        }
                        helperText={
                          formikOtp.touched.name && formikOtp.errors.name
                        }
                      />
                    </div>

                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="phone"
                        name="phone"
                        label="Phone Number *"
                        type="text"
                        value={formikOtp.values.phone}
                        onChange={formikOtp.handleChange}
                        disabled={customerDataloaded ? true : false}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.phone &&
                          Boolean(formikOtp.errors.phone)
                        }
                        helperText={
                          formikOtp.touched.phone && formikOtp.errors.phone
                        }
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="email"
                        name="email"
                        label="Email"
                        type="text"
                        value={formikOtp.values.email}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.email &&
                          Boolean(formikOtp.errors.email)
                        }
                        helperText={
                          formikOtp.touched.email && formikOtp.errors.email
                        }
                      />
                    </div>
                    {/* <div>
                      <Autocomplete
                        disablePortal
                        id="state"
                        className=" "
                        name="state"
                        options={stateList}
                        value={
                          stateList.find(
                            (opt) => opt.label === formikOtp.values.state
                          ) || null
                        }
                        onChange={(e, value) => {
                          formikOtp.setFieldValue("state", value?.label || "");
                          pullCityList(value?.id);
                        }}
                        onBlur={() => formikOtp.setFieldTouched("state", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-2 w-100"
                            label="Select State"
                            error={
                              formikOtp.touched.state &&
                              Boolean(formikOtp.errors.state)
                            }
                            helperText={
                              formikOtp.touched.state && formikOtp.errors.state
                            }
                          />
                        )}
                      />
                    </div>
                    <div>
                      <Autocomplete
                        disablePortal
                        className=""
                        id="city"
                        name="city"
                        options={cityList}
                        value={
                          cityList.find(
                            (opt) => opt.label === formikOtp.values.city
                          ) || null
                        }
                        onChange={(e, value) => {
                          formikOtp.setFieldValue("city", value?.label || "");
                        }}
                        onBlur={() => formikOtp.setFieldTouched("city", true)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            className="mb-2 w-100"
                            label="Select city"
                            error={
                              formikOtp.touched.city &&
                              Boolean(formikOtp.errors.city)
                            }
                            helperText={
                              formikOtp.touched.city && formikOtp.errors.city
                            }
                          />
                        )}
                      />
                    </div>
                    <div className="">
                      <TextField
                        className="mb-2 w-100"
                        variant="standard"
                        id="pincode"
                        name="pincode"
                        label="Pincode *"
                        type="text"
                        value={formikOtp.values.pincode}
                        onChange={formikOtp.handleChange}
                        onBlur={formikOtp.handleBlur}
                        error={
                          formikOtp.touched.pincode &&
                          Boolean(formikOtp.errors.pincode)
                        }
                        helperText={
                          formikOtp.touched.pincode && formikOtp.errors.pincode
                        }
                      />
                    </div> */}
                    <div className="f12 mb-2">
                      <div className="d-flex align-items-center">
                        <div>
                          {" "}
                          <FormGroup>
                            <FormControlLabel
                              className="f14"
                              control={
                                <Checkbox
                                  className="f14"
                                  checked={agree}
                                  onChange={haveAgree}
                                />
                              }
                              label=""
                            />
                          </FormGroup>
                        </div>
                        <div className="f12">
                          I hereby consent to <span className="fw-bold">Honda India Power Products Ltd.</span> and its <span className="fw-bold">authorised dealers</span> collecting, processing, and using my personal data
                          {
                            showConsent && <>
                              <br />
                              <span>
                                (such as name, mobile number, email ID, and enquiry details) for the limited purpose of responding to my enquiry, sharing product information, facilitating buy/sell requests, and providing related assistance on the <span className="fw-bold">HI Value<sup>+</sup> platform.</span>
                                I understand that my personal data will be <span className="fw-bold">securely stored</span> and used strictly in accordance with Honda India Power Products Ltd.’s <span className="fw-bold">Privacy Notice</span> and applicable data protection laws. My data will be retained only for as long as necessary to fulfil the stated purpose or as required by law.
                                I am aware of my rights as a <span className="fw-bold">data principal</span>, including the right to access, correct, withdraw consent, or request deletion of my personal data at any time. I may withdraw my consent by contacting Honda India Power Products Ltd. through the details provided in the Privacy Policy.
                              </span>
                            </>
                          }
                          <span className="cursor-pointer linkblue fw-semibold" onClick={() => { setShowConsent(!showConsent) }}>{showConsent ? " ..See Less" : " ..See More"}</span>

                          {/* <Link to="/terms-of-use" target="_blank">
                            Terms & Privacy Policy
                          </Link> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-2">
                      <ReCAPTCHA
                        style={{ display: "inline-block" }}
                        theme="light"
                        ref={recaptchaRef}
                        sitekey={TEST_SITE_KEY}
                        onChange={onVerifyCaptcha}
                        onExpired={() => {
                          recaptchaRef.current.reset();
                          setCaptchavalue("");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-12">
                    <div className="relative w-full mb-3">
                      <Button
                        variant="contained"
                        disabled={!enabledbtncapt}
                        className="w-100 hivalueplusSubmitBtn"
                        type="submit"
                      >
                        Get OTP
                      </Button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        show={Verificationshow}
        backdrop="static"
        keyboard={false}
        contentClassName="border-0 rounded-0"
        onHide={() => setVerificationShow(false)}
        aria-labelledby="video-lg"
      >
        <Modal.Body className="p-0">
          <div
            onClick={() => setVerificationShow(false)}
            aria-label="delete"
            size="small"
            className="position-absolute top-0 end-0 btn-out"
          >
            <CloseIcon fontSize="small" className="text-white" />
          </div>
          <div className="px-5 m-5">
            <div className="row">
              <div className="col-12 txtdgray text-center py-4">
                {otpverificationresponse}
              </div>
              <div className="col-12 d-flex justify-content-center mt-2">
                <div
                  className="hivalueplussectionBtn d-flex justify-content-center align-items-center p-2"
                  style={{ width: "120px" }}
                  onClick={() => {
                    setVerificationShow(false);
                  }}
                >
                  OK
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>


      <HIFotterMain />
    </>
  );
};

export default HIProductList;     